// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__WCgzB","form":"styles_form__KsZ1t","submit":"styles_submit__CgaLr"};